var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("vue-simple-header", [
        _c("span", { attrs: { slot: "headerTitle" }, slot: "headerTitle" }, [
          _vm._v("Wikis List"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { slot: "panelRight" }, slot: "panelRight" },
          [
            _c("vue-folder-button", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.createWikiVisible,
                  expression: "createWikiVisible",
                },
              ],
              attrs: {
                "no-text-on-mobile": true,
                text: "Create Wiki",
                "icon-class": "fa-plus",
              },
              nativeOn: {
                click: function ($event) {
                  return _vm.createWiki.apply(null, arguments)
                },
              },
            }),
            _vm._v(" "),
            _c("vue-search-input", {
              on: { search: _vm.onSearch, cancel: _vm.onSearchCancel },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.isWikiUser && _vm.myWikis.length && !_vm.query
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm-12 list_header" }, [
              _vm._v(
                "\n            My Wikis (" +
                  _vm._s(_vm.myWikis.length) +
                  ")\n        "
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isWikiUser && _vm.myWikis.length && !_vm.query
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-12" },
              _vm._l(_vm.myWikis, function (wiki) {
                return _c("wikis-shared-list-wiki", {
                  key: wiki.id,
                  attrs: { wiki: wiki, "show-owner": false },
                  on: {
                    changeWikiTemplate: function ($event) {
                      return _vm.changeWikiTemplate(wiki)
                    },
                  },
                })
              }),
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.managedItemsCount && !_vm.sharedItemsCount
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.wikis.length,
                  expression: "wikis.length",
                },
              ],
              staticClass: "row",
            },
            [
              _c("div", { staticClass: "col-sm-12 list_header" }, [
                _vm._v(
                  "\n            Wikis I Manage (" +
                    _vm._s(_vm.managedItemsCount) +
                    ")\n        "
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.managedItemsCount && _vm.sharedItemsCount
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.wikis.length,
                  expression: "wikis.length",
                },
              ],
              staticClass: "row",
            },
            [
              _c("div", { staticClass: "col-sm-12 list_header" }, [
                _vm._v(
                  "\n            Wikis shared with me (" +
                    _vm._s(_vm.sharedItemsCount) +
                    ")\n        "
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.managedItemsCount && _vm.sharedItemsCount
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-12" },
              [
                _c(
                  "tabs",
                  {
                    attrs: { justified: "" },
                    on: { "before-change": _vm.changeTab },
                    model: {
                      value: _vm.tabIndex,
                      callback: function ($$v) {
                        _vm.tabIndex = $$v
                      },
                      expression: "tabIndex",
                    },
                  },
                  [
                    _c("tab", [
                      _c(
                        "p",
                        {
                          staticStyle: {
                            "font-size": "19px",
                            "font-weight": "bold",
                          },
                          attrs: { slot: "title" },
                          slot: "title",
                        },
                        [
                          _vm._v(
                            "Wikis I Manage (" +
                              _vm._s(_vm.managedItemsCount) +
                              ")"
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("tab", [
                      _c(
                        "p",
                        {
                          staticStyle: {
                            "font-size": "19px",
                            "font-weight": "bold",
                          },
                          attrs: { slot: "title" },
                          slot: "title",
                        },
                        [
                          _vm._v(
                            "Wikis shared with me (" +
                              _vm._s(_vm.sharedItemsCount) +
                              ")"
                          ),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "infinite-scroll",
              rawName: "v-infinite-scroll",
              value: _vm.loadMore,
              expression: "loadMore",
            },
          ],
          staticClass: "row",
        },
        [
          _c(
            "div",
            { staticClass: "col-sm-12" },
            _vm._l(_vm.wikis, function (wiki) {
              return _c("wikis-shared-list-wiki", {
                key: wiki.id,
                attrs: { wiki: wiki },
                on: {
                  changeWikiTemplate: function ($event) {
                    return _vm.changeWikiTemplate(wiki)
                  },
                },
              })
            }),
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.allLoaded &&
                _vm.wikis.length === 0 &&
                (_vm.query || _vm.myWikis.length === 0),
              expression:
                "allLoaded&&wikis.length===0&&(query||(myWikis.length===0))",
            },
          ],
          staticClass: "row text-center",
        },
        [_vm._m(0)]
      ),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "text-center" }, [
            _c("span", [_vm._v("Loading...")]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-12" }, [
      _c("span", { staticStyle: { "font-size": "20px" } }, [
        _vm._v("No results..."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }